module.exports = __webpack_public_path__ + "static/media/logoviacon_app_login.c9f5e68f.svg";